/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

    var eventWasTriggered = false;

	function initEventListeners(){

		pipEvents.calculator.quantityCalculatorStateChanged.on(function(evtType, data){
			pushAnalyticsEvent();
		});

        pipEvents.calculator.measureCalculatorStateChanged.on(function(evtType, data){
			pushAnalyticsEvent();
		});

	}

	function pushAnalyticsEvent(eventName){
        if(!eventWasTriggered) {
    		var obj ={
    			category:{
    				primaryCategory: 'interaction'
    			},
    			eventInfo: {
    				eventName: 'pip sub-content'
    			},
                subContent: {
                    section: 'buybox',
                    component: 'system',
                    target: 'quantity calculator',
                    position: ''
                }
    		};

    		if (pip.debugMode) console.log('DDO Calculator Event', obj);

    		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
        }

        eventWasTriggered = true;

	}

	return {
		init: function(){
			initEventListeners();
		}
	}


});

}.call(window));